import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { Box, Button } from '@versumstudios/ui';

interface ILinkComponent {
  url: string;
  label: string;
}

export const LinkComponent: FC<ILinkComponent> = ({ url, label }) => {
  const router = useRouter();
  return (
    <Box>
      <Link href={url} locale={router.locale} prefetch={false} passHref>
        <Button as="a" variant="basic">
          <Box>{label}</Box>
        </Button>
      </Link>
    </Box>
  );
};
